module.exports = __webpack_public_path__ + "catalog/items/bathroom/corner-bath/corner-bath.svg";